import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

export default async campaignId => {
  const query = `query ($campaignId:ID!) {
      campaign(id:$campaignId){
        cityPlans {
          nodes {
            id
            city {
                name
                morningCheckingTime
                lunchCheckInTime
                afternoonCheckInTime
                morningCheckInTimeBefore
                lunchCheckInTimeBefore
                afternoonCheckInTimeBefore
                morningCheckInTimeAfter
                lunchCheckInTimeAfter
                afternoonCheckInTimeAfter
                timezone                
            }
            missions {
                edges {
                    node {
                        id
                        status
                        cancelled
                        dateTime
                    }
                }
                totalCount
            }
            }
        }
    }
}`

  const response = await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
  return response.json()
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/CityPlans/gql.js